const REGION = {
  YAMAGUCHI_KYUSHU: "YAMAGUCHI_KYUSHU",
  CHUSHIKOKU: "CHUSHIKOKU"
} as const;

type Region = (typeof REGION)[keyof typeof REGION];

const PREFIX_TO_REGION: Record<string, Region> = {
  R: REGION.YAMAGUCHI_KYUSHU,
  RA: REGION.CHUSHIKOKU
};

const ESTATE_ID_PATTERN = new RegExp(
  `^(${Object.keys(PREFIX_TO_REGION)
    .sort((a, b) => b.length - a.length)
    .join("|")})-(\\d+)$`
);

export function parseEstateId(id: string): {
  prefix: string;
  recNo: number;
  region: Region;
} {
  const match = id.match(ESTATE_ID_PATTERN);

  if (!match) {
    throw new Error(`Invalid estate id: ${id}`);
  }

  const prefix = match[1];
  const recNo = parseInt(match[2], 10);
  const region = PREFIX_TO_REGION[prefix];

  if (region === undefined) {
    throw new Error(`Unknown estate id prefix: ${prefix}`);
  }

  return { prefix, recNo, region };
}
